// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__269Kq","footer":"styles_footer__16Bj9","passCodeTooltip":"styles_passCodeTooltip__9LI7j"};